export function parseCSV (csvData) {
  const lines = csvData.trim().split('\n')
  const headers = lines[0].replace(', ', ' ').split(',')
  const rows = lines.slice(1).map(line =>
    line
      .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
      .map(field =>
        field
          .trim()
          .replace(/^"(.*)"$/, '$1')
          .replace(/^--,\s*/, '')
      )
  )

  return { headers, rows }
}
